<div class="add-container">
    <h1 class="add-title">Adaugă o cerere</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Subiect</mat-label>
                    <input type="text" matInput formControlName="subject" />
                    <mat-error *ngIf="!form.controls['subject'].valid && form.controls['subject'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Prioritate</mat-label>
                    <mat-select formControlName="id_cerere_priority">
                        <mat-option *ngFor="let row of prioritatiCerere$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
				        !form.controls['id_cerere_priority'].valid &&
				        form.controls['id_cerere_priority'].touched
			        ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Departament</mat-label>
                    <mat-select formControlName="id_departament"
                        (selectionChange)="onCompartimenteChange($event.value)">
                        <mat-option *ngFor="let row of compartimenteDeps$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
				        !form.controls['id_departament'].valid &&
				        form.controls['id_departament'].touched
			        ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip</mat-label>
                    <mat-select formControlName="id_cerere_type">
                        <mat-option *ngFor="let row of tipuriCerere$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
				        !form.controls['id_cerere_type'].valid &&
				        form.controls['id_cerere_type'].touched
			        ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Responsabil</mat-label>
                    <mat-select formControlName="id_user_assigned">
                        <mat-option *ngFor="let row of operatori$ | async" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="
				        !form.controls['id_user_assigned'].valid &&
				        form.controls['id_user_assigned'].touched
			        ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col">
                <mat-checkbox formControlName="check_cetatean" color="primary" (click)="toggleCetatean()">
                    <h3 class="mb-0">Cetățean?</h3>
                </mat-checkbox>
            </div>
        </div>

        <!-- formCetatean start -->
        <form [formGroup]="formCetatean" *ngIf="showCetateanFields">
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Nume</mat-label>
                        <input type="text" matInput formControlName="cet_nume" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_nume'].valid && formCetatean.controls['cet_nume'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Prenume</mat-label>
                        <input type="text" matInput formControlName="cet_prenume" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_prenume'].valid && formCetatean.controls['cet_prenume'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Telefon</mat-label>
                        <input type="text" matInput formControlName="cet_telefon" />
                        <mat-error *ngIf="
                                formCetatean.controls['cet_telefon'].hasError('invalidPhone') &&
                                formCetatean.controls['cet_telefon'].touched
                            ">
                            Număr de telefon invalid
                        </mat-error>
                        <mat-error *ngIf="
                                    !formCetatean.controls['cet_telefon'].hasError('invalidPhone') && 
                                    !formCetatean.controls['cet_telefon'].valid && 
                                    formCetatean.controls['cet_telefon'].touched
                                ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 ">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="cet_email" />
                        <mat-error
                            *ngIf="formCetatean.controls['cet_email'].hasError('email') && formCetatean.controls['cet_email'].touched">
                            Email invalid
                        </mat-error>
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_email'].hasError('email') && !formCetatean.controls['cet_email'].valid && formCetatean.controls['cet_email'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>CNP</mat-label>
                        <input type="number" matInput formControlName="cet_cnp" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_cnp'].valid && formCetatean.controls['cet_cnp'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>CI Serie</mat-label>
                        <input type="text" matInput formControlName="cet_ci_serie" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_ci_serie'].valid && formCetatean.controls['cet_ci_serie'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>CI Număr</mat-label>
                        <input type="number" matInput formControlName="cet_ci_numar" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_ci_numar'].valid && formCetatean.controls['cet_ci_numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Județ</mat-label>
                        <mat-select formControlName="cet_adr_judet">
                            <mat-option *ngFor="let row of judete$ | async" [value]="row.id">
                                {{ row.name }}
                            </mat-option>
                            <!-- <mat-option *ngFor="let row of judete" [value]="row.id">
                                {{ row.name }}
                            </mat-option> -->
                        </mat-select>
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_adr_judet'].valid && formCetatean.controls['cet_adr_judet'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Oraș</mat-label>
                        <input type="text" matInput formControlName="cet_adr_oras" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_adr_oras'].valid && formCetatean.controls['cet_adr_oras'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Sector</mat-label>
                        <mat-select formControlName="cet_adr_sector">
                            <mat-option *ngFor="let row of sectoare" [value]="row.id">
                                {{ row.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 ">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Stradă</mat-label>
                        <input type="text" matInput formControlName="cet_adr_strada" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_adr_strada'].valid && formCetatean.controls['cet_adr_strada'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="cet_adr_numar" />
                        <mat-error
                            *ngIf="!formCetatean.controls['cet_adr_numar'].valid && formCetatean.controls['cet_adr_numar'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Bloc</mat-label>
                        <input type="text" matInput formControlName="cet_adr_bloc" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Scară</mat-label>
                        <input type="text" matInput formControlName="cet_adr_scara" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Etaj</mat-label>
                        <input type="text" matInput formControlName="cet_adr_etaj" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Apartament</mat-label>
                        <input type="text" matInput formControlName="cet_adr_apartament" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Observații adresă</mat-label>
                        <textarea matInput formControlName="cet_adr_observatii" name="cet_adr_observatii"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <!-- formCetatean end -->

        <div class="row mb-3">
            <div class="col">
                <h3 class="mb-0">Descriere</h3>
                <angular-editor formControlName="description" [config]="editorConfig"></angular-editor>
                <mat-error *ngIf="!form.controls['description'].valid &&form.controls['description'].touched">
                    Câmp obligatoriu
                </mat-error>
            </div>
        </div>

        <div class="document-upload mb-3">
            <div class="document-upload-header">
                <p class="upload-text">Fotografii/Documente</p>
                <button class="upload-btn" (click)="fileInput.click()" type="button">
                    <mat-icon class="upload-icon me-2">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="document-upload-files" *ngIf="
                    form.value.files.length > 0 &&
                    !uploading
                ">
                <div class="document-upload-file" *ngFor="
                        let uploadedFile of form.value.files;
                        let i = index
                    ">
                    <span class="document-upload-file-name">
                        {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name | slice : 0 : 30) + ".."
                        : uploadedFile.original_name
                        }}
                    </span>
                    <div>
                        <button class="document-upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat"
                            (click)="removeFile(i)">
                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event)" multiple
                style="display: none" />
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary"
                    [disabled]="form.invalid || (formCetatean.invalid && showCetateanFields)">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>